(() => {
  const mediaId = (item) => item?.querySelector('.product-media')?.dataset.mediaId || '';

  const setActiveThumb = (items, activeItem) => {
    items.forEach((item) => {
      const isActive = item === activeItem;
      item.classList.toggle('trots-gallery-thumb--active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const enhanceGallery = (gallery) => {
    if (!gallery || gallery.dataset.trotsGalleryEnhanced === 'true') return;

    const slideshow = gallery.querySelector('slideshow-component');
    const grid = gallery.querySelector('.media-gallery__grid');

    if (!slideshow || !grid || typeof slideshow.select !== 'function') return;

    gallery.dataset.trotsGalleryEnhanced = 'true';
    const items = Array.from(grid.querySelectorAll('.product-media-container'));
    const indexByMediaId = new Map();

    items.forEach((item, index) => {
      const id = mediaId(item);
      if (id) indexByMediaId.set(id, index);
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
    });

    setActiveThumb(items, items[0]);

    const selectItem = (item, event) => {
      const id = mediaId(item);
      const index = indexByMediaId.get(id) ?? items.indexOf(item);
      if (index < 0) return;

      event?.preventDefault();
      slideshow.select(index, event, { animate: false });
      setActiveThumb(items, item);
    };

    grid.addEventListener('click', (event) => {
      const item = event.target.closest('.product-media-container');
      if (!item || !grid.contains(item)) return;

      selectItem(item, event);
    });

    grid.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const item = event.target.closest('.product-media-container');
      if (!item || !grid.contains(item)) return;

      selectItem(item, event);
    });
  };

  const enhanceAll = () => {
    if (!document.querySelector('[data-testid="product-information"]')) return;

    document.querySelectorAll('media-gallery').forEach(enhanceGallery);
  };

  document.addEventListener('DOMContentLoaded', enhanceAll);
  document.addEventListener('shopify:section:load', enhanceAll);
  new MutationObserver(enhanceAll).observe(document.documentElement, { childList: true, subtree: true });
})();
